export default __webpack_public_path__ + "static/media/EditorGif.60b08c77.gif";